// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__qlaHB","react-loading-skeleton":"Skeleton_react-loading-skeleton__IEr9d"};